import defaultTemplate from './default.hbs';

export default {
  default: defaultTemplate
};
